import React, { useEffect, useState } from "react";
import { ReactComponent as LoadingIcon } from "../../../assets/images/svg-icon/cpanel-loading.svg";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Modal, Box, Typography, Checkbox, TextField, InputAdornment, IconButton } from "@mui/material";
import { url } from '../../../Constant';
import './usercss.css'

const ChangePasswordModal = () => {
  const [open, setOpen] = useState(true);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  const [loading, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState({
    password: "",
    confirmPassword: "",
  });

  const passwordCriteria = [
    { id: 1, label: "At least 8 characters", regex: /.{8,}/ },
    { id: 2, label: "One uppercase letter", regex: /[A-Z]/ },
    { id: 3, label: "One lowercase letter", regex: /[a-z]/ },
    { id: 4, label: "One number", regex: /\d/ },
    { id: 5, label: "One special character", regex: /[@$!%*?&#]/ },
  ];

  const handleClose = () => {
    setOpen(false);
    setPassword("");
    setConfirmPassword("");
    setError("");
  };

  const handlePasswordChange = (e) => {
    const allCriteriaMet = passwordCriteria.every((criterion) =>
      criterion.regex.test(e.target.value)
    );
    setPassword(e.target.value);
    if (allCriteriaMet) {
      setError({ ...error, password: "" });
      return;
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value)
    if(value == password)setError({...error, confirmPassword:""})
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async () => {
    const allCriteriaMet = passwordCriteria.every((criterion) =>
      criterion.regex.test(password)
    );

    if (!allCriteriaMet) {
      setError({ ...error, password: "Please ensure all password requirements are met." });
      return;
    } else {
      // alert()
      setError({ ...error, password: null });
    }

    if (password !== confirmPassword) {
      setError({ ...error, confirmPassword: "Passwords do not match." });
      // setError("Passwords do not match.");
      return;
    } else {
      setError({ ...error, confirmPassword: "" });

    }

    setError(""); // Clear errors if validation passes
    setLoading(true);

    const token = localStorage.getItem('token'); // Replace with actual token

    try {
      const response = await fetch(`${url}/auth/updatePassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        throw new Error("Failed to update password.");
      }

      const data = await response.json();
      // alert("Password updated successfully!");
      // window.open("/panel/dashboard", "_blank")
      // setTimeout(() => {
      //   window.location.reload();
      // }, 100)
      handleClose();
    } catch (error) {
      setError(error.message || "An error occurred while updating password.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{

  },[])

  return (
    <Modal style={{ display: "flex", alignSelf: "center", borderColor:"#fff" }} open={open}>
      <Box
        sx={{
          width: 450,
          bgcolor: "background.paper",
          p: 3,
          borderRadius: 2,
          mx: "auto",
          mt: "auto",
          boxShadow: 24,
          boder:0,
          borderColor:"#fff"
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          textAlign="center"
          sx={{ fontWeight: "bold" }}
        >
          Change Password
        </Typography>

        {/* {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )} */}

        <div className="col-lg-12 col-md-12 col-sm-12 form-group mt-4">
          {/* <input
            type="text"
            style={{ backgroundColor: "#EEF2FE", borderColor: "#EEF2FE" }}
            placeholder="Password *"
            value={password}
            onChange={handlePasswordChange}
          />
          {error.password && (
            <Typography variant="p" color="error" sx={{ mt: 2, fontSize: "0.7vw" }}>
              {error.password}
            </Typography>
          )} */}

          <TextField
            error={error.password !== ''}
            fullWidth
            id="password"
            label="Password"
            type={!showPassword ? 'text' : 'password'}
            value={password}
            onChange={handlePasswordChange}
            helperText={error.password}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={togglePasswordVisibility}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                height: '45px', // Adjust the height as needed
                fontSize: '0.7vw', // Adjust the font size as needed
                borderRadius: 30,
                backgroundColor: "#fff"
              }
            }}
            InputLabelProps={{
              sx: {
                fontSize: '0.8vw', // Adjust the label font size as needed
              }
            }}
            FormHelperTextProps={{
              sx: {
                fontSize: '0.6vw', // Adjust the helper text font size as needed
              }
            }}
          />
          <div style={{ marginTop: "10px" }}>
            {passwordCriteria.map((criterion) => (
              <div key={criterion.id} style={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  checked={criterion.regex.test(password)}
                  color="success"
                  disabled
                />
                <Typography
                  variant="body2"
                  color={criterion.regex.test(password) ? "green" : "textSecondary"}
                >
                  {criterion.label}
                </Typography>
              </div>
            ))}
          </div>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 form-group mt-4">
          {/* <input
            type="text"
            style={{ backgroundColor: "#EEF2FE", borderColor: "#EEF2FE" }}
            placeholder="Confirm Password *"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {error.confirmPassword && (
            <Typography variant="p" color="error" sx={{ mt: 2, fontSize: "0.7vw" }}>
              {error.confirmPassword}
            </Typography>
          )} */}

          <TextField
            error={error.confirmPassword !== ''}
            fullWidth
            id="confirmPassword"
            label="Confirm Password"
            type={'password'}
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            helperText={error.confirmPassword}
            required
            InputProps={{
              sx: {
                height: '45px', // Adjust the height as needed
                fontSize: '0.7vw', // Adjust the font size as needed
                borderRadius: 30,
                backgroundColor: "#fff"
              }
            }}
            InputLabelProps={{
              sx: {
                fontSize: '0.8vw', // Adjust the label font size as needed
              }
            }}
            FormHelperTextProps={{
              sx: {
                fontSize: '0.6vw', // Adjust the helper text font size as needed
              }
            }}
          />
        </div>

        <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn mt-4">
          {loading ? (
            <LoadingIcon
              style={{
                height: 50,
                width: "100%",
              }}
            />
          ) : (
            <button
              className="theme-btn-frontend"
              type="button"
              name="submit-form"
              onClick={handleSubmit}
              disabled={loading}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
                width: "100%",
              }}
            >
              Change Password
            </button>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default ChangePasswordModal;
